import { Dialog } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";
import type { OrderHistoryRow } from "@/lib/orders";

export type OrderStornoDialogMode = "cancel" | "restore";

function orderLabel(row: OrderHistoryRow): string {
  return (row.bestellnummern || row.supplier_name || `Bestellung #${row.id}`).trim();
}

export function OrderStornoDialog({
  open,
  mode,
  row,
  loading,
  onClose,
  onConfirm,
}: {
  open: boolean;
  mode: OrderStornoDialogMode;
  row: OrderHistoryRow | null;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const label = row ? orderLabel(row) : "";
  const isCancel = mode === "cancel";

  return (
    <Dialog
      open={open}
      onClose={loading ? () => {} : onClose}
      size="sm"
      zIndexClass="z-[130]"
      title={isCancel ? "Bestellung stornieren" : "Stornierung aufheben"}
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onClose} disabled={loading}>
            Abbrechen
          </Button>
          <Button
            type="button"
            variant={isCancel ? "danger" : "primary"}
            onClick={onConfirm}
            loading={loading}
          >
            {isCancel ? "Stornieren" : "Stornierung aufheben"}
          </Button>
        </>
      }
    >
      {isCancel ? (
        <p className="text-sm leading-relaxed text-label-secondary">
          Bestellung <span className="font-semibold text-label">„{label}“</span> wirklich als storniert
          markieren?
          <br />
          <br />
          Die Positionen bleiben in der Projektübersicht sichtbar, werden aber nicht mehr in
          Stundennachweisen vorgeschlagen.
        </p>
      ) : (
        <p className="text-sm leading-relaxed text-label-secondary">
          Stornierung für Bestellung <span className="font-semibold text-label">„{label}“</span>{" "}
          aufheben?
          <br />
          <br />
          Die Bestellung erscheint danach wieder als aktiv und kann in Stundennachweisen vorgeschlagen
          werden.
        </p>
      )}
    </Dialog>
  );
}
